import React from 'react';
import Asset from '@src/components/Asset';
import Carousel from '@src/components/glide/Glide';

export default function ImageCarousel(props) {
    const { images } = props;

    const carouselOptions = {
        type: 'slider',
        autoplay: 6000,
        animationDuration: 1000,
        bound: true,
        perView: 1,
        startAt: 0,
        peek: 0,
        gap: 24,
    };

    return (
        <Carousel enabled options={carouselOptions} arrows>
            {images.map(item => (
                <div key={item.imageFile}>
                    <Asset data={item.imageFile} title={item.title} />
                </div>
            ))}
        </Carousel>
    );
}
